import * as React from 'react';

import styles from './FlowPickerItem.module.scss';

interface IProps {
  title?: string | React.ReactNode;
  description?: string;
  onClick?: (...args: any[]) => void;
  icon: React.ReactNode;
  dataAction?: string;
}

const FlowPickerItem: React.FC<IProps> = ({ dataAction, title, description, onClick, icon }) => {
  return (
    <div className={styles.flowPickerItem} onClick={onClick} data-action={dataAction}>
      <div className={styles.iconInner}>
        <div className={styles.icon} style={{ backgroundImage: `url(${icon})` }} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default FlowPickerItem;
